export default __webpack_public_path__ + "images/venda-avulsa-ico.svg";